'use client';
import styled from 'styled-components';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${props => props.theme.colors.neutral.white};

  @media ${props => props.theme.tablet} {
    flex-direction: row;
    min-height: 600px;
  }
`;

export const Media = styled.div`
  position: relative;
  width: 100%;
  height: 312px;
  overflow: hidden;
  background-color: ${props => props.theme.colors.hero.lilac};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
  }

  @media ${props => props.theme.tablet} {
    order: 2;
    width: 50%;
    height: auto;
    min-height: 600px;
  }
`;

export const DesktopImage = styled.div`
  display: ${props => (props.$hasMobile ? 'none' : 'block')};
  position: relative;
  width: 100%;
  height: 100%;

  @media ${props => props.theme.tablet} {
    display: block;
  }
`;

export const MobileImage = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;

  @media ${props => props.theme.tablet} {
    display: none;
  }
`;

export const Copy = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  padding: ${props => props.theme.spacing(10, 6, 12)};

  @media ${props => props.theme.tablet} {
    order: 1;
    width: 50%;
    padding: ${props => props.theme.spacing(16, 12)};
  }

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(20, 24)};
  }
`;

export const CopyInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${props => props.theme.spacing(8)};
  max-width: 512px;

  @media ${props => props.theme.tablet} {
    gap: ${props => props.theme.spacing(12)};
  }
`;

export const Header = styled.h2`
  ${props => props.theme.typography.heading2}
  color: ${props => props.theme.colors.neutral.darkest};
  margin: 0;
`;

export const SubHeader = styled.p`
  ${props => props.theme.typography.body}
  color: ${props => props.theme.colors.text.secondary};
  margin: 0;
`;

export const OllieAppButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${props => props.theme.spacing(6)};

  a {
    display: block;
    line-height: 0;
  }

  img {
    width: auto;
    height: 64px;
  }

  @media ${props => props.theme.tablet} {
    flex-direction: row;
    align-items: center;
  }
`;
